  <div class="pad-left pad-top row">
     <div class="welcome-header-text column1">
       <div class="subheader-subline">
         Thank you for your participation in this Accelerator Tool.
         <br/><br/>
         A copy of the full report has been sent to your business email address.
         <br/><br/><br/>
         Click to return.
         <br/><br/>
         <button class="back-button" (click)="back()">OK</button>
       </div>
     </div>
     <div class="welcome-header-image column1">
         <img class="welcome-image" src="assets/images/welcome0.jpg">
     </div>
  </div>
  <br/><br/><br/>
